// @flow
import * as React from "react";

import { Routes, Route } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";

import PageLoader from "views/UI/PageLoader";

import GuestRoute from "views/utils/hoc/GuestRoute";
import PrivateRoute from "views/utils/hoc/PrivateRoute";

const AuthLayout = React.lazy(() => import("App/layouts/AuthLayout"));
const AppLayout = React.lazy(() => import("App/layouts/AppLayout"));
const Main = React.lazy(() => import("App/Main"));
const Login = React.lazy(() => import("views/pages/Login"));
const Signup = React.lazy(() => import("views/pages/Signup"));
const EmailConfirmation = React.lazy(() => import("views/pages/EmailConfirmation"));
const ForgotPassword = React.lazy(() => import("views/pages/ForgotPassword"));
const ResetPassword = React.lazy(() => import("views/pages/ResetPassword"));
const SetPassword = React.lazy(() => import("views/pages/SetPassword"));
const LoginAsAffiliate = React.lazy(() => import("views/pages/LoginAsAffiliate"));
const OfferPreview = React.lazy(() => import("views/pages/OfferPreview"));

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

function App(): React.Node {
  return (
    <QueryClientProvider client={queryClient}>
      <React.Suspense fallback={<PageLoader />}>
        <Routes>
          <Route element={<GuestRoute />}>
            <Route element={<AuthLayout />}>
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/email-confirmation/:token" element={<EmailConfirmation />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password/:token" element={<ResetPassword />} />
              <Route path="/set-password/:token" element={<SetPassword />} />
            </Route>
          </Route>

          <Route path="/offer-previews/:id" element={<OfferPreview />} />

          <Route element={<PrivateRoute />}>
            <Route element={<AppLayout />}>
              <Route path="/login-as-affiliate/:id" element={<LoginAsAffiliate />} />
              <Route path="/*" element={<Main />} />
            </Route>
          </Route>
        </Routes>

        <ReactQueryDevtools initialIsOpen={false} />
      </React.Suspense>
    </QueryClientProvider>
  );
}

export default App;
